import { dataHooks } from '../../../libs/dataHooks';

export const microCategoriesDataHooks = dataHooks<{
  container: {};
  tagLink: {};
}>('micro-categories');
